export const NavbarLinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Find a Practitioner",
    path: "/find-a-practitioner",
  },
  {
    title: "AURA",
    path: "/aura",
  },
  {
    title: "Pricing",
    path: "/pricing",
  },
  {
    title: "Careers",
    path: "/careers",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];
